import React from 'react';

import { Container, Title, Image, LinkButton } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';

export const ResetPasswordSuccess = () => {
  return (
    <AuthLayout justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="reset-password" src="/assets/img/reset-password.svg" />
        </Container>
        <Title mb="m">Password changed!</Title>
        <Title type="h3" variant="grey">
          Your password has been changed.
        </Title>
        <LinkButton my="m" to="/sign-in">
          Log in
        </LinkButton>
      </Container>
    </AuthLayout>
  );
};
